module.exports = __webpack_public_path__ + "media/2.36f00be1.mp3";